"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBy = void 0;
var FilterByImpl_1 = require("./FilterByImpl");
var FilterBy = /** @class */ (function () {
    function FilterBy(config, contentClient) {
        this.config = config;
        this.contentClient = contentClient;
        this.requestConfig = {
            filterBy: [],
        };
        this.filterByService = new FilterByImpl_1.FilterByImpl(this.config, this.contentClient);
    }
    /**
     *  This function will help construct requests for filtering Content Items or Slots
     *
     * @param path - json path to the property you wish to filter by e.g `/_meta/schema`
     * @param value - value you want to return matches for
     *
     * @returns `FilterBy<Body>`
     */
    FilterBy.prototype.filterBy = function (path, value) {
        this.requestConfig.filterBy.push({
            path: path,
            value: value,
        });
        return this;
    };
    /**
     *
     *  equivalent to:
     *
     * ```ts
     *  client.filterBy('/_meta/schema', contentTypeUri)
     * ```
     *
     * @param contentTypeUri - Content Type Uri you want to filter
     *
     * @returns `FilterBy<Body>`
     */
    FilterBy.prototype.filterByContentType = function (value) {
        return this.filterBy(FilterBy.SCHEMA_PATH, value);
    };
    /**
     * Fetch content by parent id
     *
     * equivalent to:
     *
     * ```ts
     *  client.filterBy('/_meta/hierarchy/parentId', id)
     * ```
     *
     * @param id - ID of a Hierarchy Content Item
     *
     * @returns `FilterBy<Body>`
     */
    FilterBy.prototype.filterByParentId = function (value) {
        return this.filterBy(FilterBy.PARENT_PATH, value);
    };
    /**
     * Set sortable key based on schema [`trait:sortable`](https://amplience.com/docs/development/contentdelivery/filterandsort.html#sorttrait)
     *
     *
     * @param key - key you wish to sort by
     * @param order - order enum ASC, DESC
     *
     * @returns `FilterBy<Body>`
     */
    FilterBy.prototype.sortBy = function (key, order) {
        this.requestConfig.sortBy = {
            key: key,
            order: order,
        };
        return this;
    };
    FilterBy.prototype.page = function (size, cursor) {
        if (!this.requestConfig.page) {
            this.requestConfig.page = {};
        }
        if (arguments.length === 1 && typeof size === 'string') {
            this.requestConfig.page.cursor = size;
            return this;
        }
        if (typeof size === 'number') {
            this.requestConfig.page.size = size;
        }
        if (cursor) {
            this.requestConfig.page.cursor = cursor;
        }
        return this;
    };
    /**
     *
     * @param parameters - api options for response format
     *
     * @returns `FilterBy<Body>`
     */
    FilterBy.prototype.request = function (parameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (parameters) {
                    this.requestConfig.parameters = parameters;
                }
                return [2 /*return*/, this.filterByService.fetch(this.requestConfig)];
            });
        });
    };
    FilterBy.SCHEMA_PATH = '/_meta/schema';
    FilterBy.PARENT_PATH = '/_meta/hierarchy/parentId';
    return FilterBy;
}());
exports.FilterBy = FilterBy;
//# sourceMappingURL=data:application/json;base64,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